export default __webpack_public_path__ + "static/media/header-background-2.2e164208.jpg";